import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [status, setStatus] = useState(null);

  const load = useCallback(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/store/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  const waLink = useCallback((msg) => {
    const num = (settings?.whatsapp_number || "").replace(/[^\d]/g, "");
    return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
  }, [settings]);

  return (
    <Ctx.Provider value={{ settings, status, waLink, refresh: load }}>
      {children}
    </Ctx.Provider>
  );
}

export const useSettings = () => useContext(Ctx);
